import { circleCenter, radioIconSize } from '@/features/ui/inputs/components/RadioButton/constants'
import { FC } from 'react'
import Svg, { Circle, SvgProps } from 'react-native-svg'

const UncheckedRadioIcon: FC<SvgProps> = (props) => {
    return (
        <Svg fill="none" stroke="currentColor" {...radioIconSize} {...props}>
            <Circle {...circleCenter} r={9} strokeWidth={2} />
        </Svg>
    )
}

export default UncheckedRadioIcon
